<script type="text/javascript">

  /**正式环境对应的IP地址 */
   const serverPath="https://www.chinesemedicalvolunteers.com:8105/";
   const serverPath1="https://www.chinesemedicalvolunteers.com:8105/";

  /**开发环境对应的IPI地址 */
  //const serverPath="http://192.168.0.106:8105/";
  //const serverPath1="http://192.168.0.106:8105/";

  export default{
      serverPath,
      serverPath1
  }
</script>



// WEBPACK FOOTER //
// src/components/Global.vue